import { STATUS } from 'src/pages/budget/const'
import { TStatus } from 'src/pages/budget/types'

export type RequestFormMode = 'editOwn' | 'editForApprove' | 'createOwn'

type FieldAccessOptions = {
  mode: RequestFormMode
  status?: TStatus
  isCeo?: boolean
  hasApprovalSteps: boolean
  initialIsEarlyPayment?: boolean
}

export const getRequestFieldDisabled = ({
  mode,
  status,
  isCeo,
  hasApprovalSteps,
  initialIsEarlyPayment,
}: FieldAccessOptions) => {
  const isNew = mode === 'createOwn'
  const isAuthor = mode === 'editOwn'
  const isReviewer = mode === 'editForApprove' && hasApprovalSteps

  const isDraft = status === STATUS.DRAFT
  const isSubmitted = status === STATUS.SUBMITTED
  const isInReview = status === STATUS.IN_REVIEW
  const isReject = status === STATUS.REJECTED

  const canEditCommon =
    isNew ||
    (isAuthor && (isDraft || isSubmitted || isReject)) ||
    (isReviewer && (isSubmitted || isInReview)) ||
    (isCeo && (isSubmitted || isInReview))

  const canEditClassification = isNew || (isAuthor && (isDraft || isReject)) // team/article/budgetPeriod

  const canEditDescription =
    isNew || (isAuthor && (isDraft || isSubmitted || isReject))

  const canEnableEarlyPayment =
    (isAuthor && (isDraft || isSubmitted || isReject)) ||
    (isCeo && !initialIsEarlyPayment && (isSubmitted || isInReview))

  return {
    description: !canEditDescription,
    amount: !canEditCommon,
    currency: !canEditCommon,
    articleItem: !canEditCommon,
    productIds: !canEditCommon,
    autoPaymentEnabled: !canEditCommon,
    autoPaymentFrequency: !canEditCommon,
    comment: !canEditCommon,
    article: !canEditClassification,
    team: !canEditClassification,
    budgetPeriod: !canEditClassification,
    isEarlyPayment: !canEnableEarlyPayment,
  }
}
